import Vue from 'vue'
import $ from 'jquery'
// eslint-disable-next-line
import slick from 'slick-carousel'

const SliderAboutUsTeam = Vue.directive('slider-about-us-team-directive', {
  bind (el) {
    $(document).ready(function () {
      const slider = $(el)
      slider.slick({
        arrows: true,
        autoplay: false,
        speed: 2000,
        draggable: true,
        dots: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      })
      // eslint-disable-next-line
      const allSlides = $('.slider-about-us-team__card').length

      slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const num = allSlides - 1

        if (currentSlide === num) {
          zero(event, slick, currentSlide, nextSlide)
        }
        if (nextSlide > currentSlide) {
          forward(event, slick, currentSlide, nextSlide)
        }
        if (nextSlide === num) {
          $('#card-0').addClass('slider-about-us-team__card--active')
        }
        if (nextSlide < currentSlide && nextSlide !== num) {
          backward(event, slick, currentSlide, nextSlide)
        }
      })

      function zero (event, slick, currentSlide, nextSlide) {
        $('#card-0').removeClass('slider-about-us-team__card--active')
      }
      function forward (event, slick, currentSlide, nextSlide) {
        const num = allSlides - 1
        if (currentSlide !== num) {
          $('#card-0').removeClass('slider-about-us-team__card--active')
        }
        let trueCurrent = nextSlide + 1
        let lastSlide = currentSlide + 1
        $('#card-' + lastSlide).removeClass('slider-about-us-team__card--active')
        $('#card-' + trueCurrent).addClass('slider-about-us-team__card--active')
      }
      function backward (event, slick, currentSlide, nextSlide) {
        let lastSlide = currentSlide + 1
        let backSlide = nextSlide + 1
        $('#card-0').removeClass('slider-about-us-team__card--active')
        $('#card-' + lastSlide).removeClass('slider-about-us-team__card--active')
        $('#card-' + backSlide).addClass('slider-about-us-team__card--active')
      }
    })
  }
})

export default SliderAboutUsTeam



// WEBPACK FOOTER //
// ./src/components/slider/slider-about-us-team/slider-about-us-team.directive.js